// Top bar for the Marketing workspace: teal eyebrow + navy H1 + subtitle,
// with the date-range segmented control on the right. Header copy is
// derived from the current route.

import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { useMarketing } from '../MarketingContext';

const HEADERS = {
  '': { eyebrow: 'Dashboard', title: null, sub: 'Here is your week and where things stand.' },
  content: { eyebrow: 'Content', title: 'Content engine', sub: 'Quarterly plan, production board, and the idea bank.' },
  social: { eyebrow: 'Social', title: 'LinkedIn weave', sub: 'One post per weekday, rotating across active series.' },
  projects: { eyebrow: 'Projects', title: 'The big rocks', sub: 'Campaigns and infrastructure work with step checklists.' },
  attribution: { eyebrow: 'Attribution', title: 'Attribution & funnel', sub: 'Where visitors, prospects, and won deals come from.' },
  email: { eyebrow: 'Email', title: 'Email performance', sub: 'Campaigns, sequences, and list health from ActiveCampaign.' },
  seo: { eyebrow: 'SEO / Search', title: 'Organic search', sub: '28-day Search Console performance and quick wins.' },
  budget: { eyebrow: 'Budget & CAC', title: 'Marketing spend', sub: 'Hard + soft dollars against the revenue goal, and CAC.' },
  planning: { eyebrow: 'Planning', title: 'Strategy & avatars', sub: 'The annual strategy, the quarter serving it, and who it is all for.' },
  'content-log': { eyebrow: 'Tools', title: 'Content log', sub: 'The full content table with SEO fields.' },
  utm: { eyebrow: 'Tools', title: 'UTM builder', sub: 'Tagged links tied to content entries.' },
};

function firstNameFromEmail(email) {
  const local = (email || '').split('@')[0] || 'there';
  return local.charAt(0).toUpperCase() + local.slice(1);
}

export default function MarketingTopBar() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { range, setRange } = useMarketing();

  const key = pathname.replace(/^\/marketing\/?/, '').split('/')[0];
  const h = HEADERS[key] || HEADERS[''];
  const title = h.title || `Welcome back, ${firstNameFromEmail(user?.email)}`;
  const showRange = key === '' || key === 'attribution';

  return (
    <div className="flex items-end justify-between gap-4 pb-4">
      <div>
        <div className="text-deep-teal text-[11px] font-black tracking-[0.14em] uppercase">{h.eyebrow}</div>
        <h1 className="text-navy text-[24px] font-black tracking-[-0.01em] mt-[3px] leading-tight">{title}</h1>
        <div className="text-ink-2 text-[13px] mt-[3px]">{h.sub}</div>
      </div>
      {showRange && (
        <div className="flex bg-white border border-line rounded-[8px] p-[3px]">
          {[['7d', '7d'], ['30d', '30d'], ['qtd', 'QTD']].map(([r, label]) => (
            <button
              key={r}
              onClick={() => setRange(r)}
              className={`text-[12px] font-bold px-3 py-1 rounded-[6px] transition-colors ${
                range === r ? 'bg-navy text-white' : 'text-ink-2 hover:text-navy'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
